<onyx-data-widget
  supheading="labels.tolls"
  [headingIcon]="{ name: 'finance-filled', size: 20, color: 'black' }"
>
  <div heading class="heading">
    <span
      [innerHTML]="
        tollsTotalPrice()
          | number: '1.2-2'
          | numberDecoration: { unit: (tolls().defaultCurrency | uppercase) }
      "
    ></span>
  </div>

  <div class="container">
    <div class="list">
      <div class="item">
        <p class="f-muted">{{ 'labels.roads' | translate }}</p>

        <app-amount-cell
          [amount]="{
            value: tolls().defaultCurrencyValue,
            currency: tolls().defaultCurrency,
          }"
          [short]="false"
        ></app-amount-cell>
      </div>
    </div>
  </div>
</onyx-data-widget>
